import Vue from 'vue'
import { API_URL } from '../../api'
import MasterAccountsFilter from '../../filters/MasterAccountsFilter';
import InvestorAccountsFilter from '../../filters/InvestorAccountsFilter';
import ProjectAccountsFilter from '../../filters/ProjectAccountsFilter';

const state = {
    masterMasterAccountCreate: {
        createdMasterAccount: null,
        creatingMasterAccount: false,
        createMasterAccountStatus: null
    },
    masterMasterAccountUpdate: {
        updatedMasterAccount: null,
        updatingMasterAccount: false,
        updateMasterAccountStatus: null
    },
    masterMasterAccountDelete: {
        deletingMasterAccount: false,
        deleteMasterAccountStatus: null
    },
    masterMasterAccountSearch: {
        masterMasterAccountsCount: null,
        masterMasterAccounts: [],
        searchingMasterAccounts: false,
        searchMasterAccountStatus: null
    },
    investorAccountCreate: {
        createdInvestorAccount: null,
        creatingInvestorAccount: false,
        createInvestorAccountStatus: null
    },
    investorAccountUpdate: {
        updatedInvestorAccount: null,
        updatingInvestorAccount: false,
        updateInvestorAccountStatus: null
    },
    investorAccountDelete: {
        deletingInvestorAccount: false,
        deleteInvestorAccountStatus: null
    },
    investorAccountSearch: {
        investorAccountsCount: null,
        investorAccounts: [],
        searchingInvestorAccounts: false,
        searchInvestorAccountStatus: null
    },
    projectAccountCreate: {
        createdProjectAccount: null,
        creatingProjectAccount: false,
        createProjectAccountStatus: null
    },
    projectAccountUpdate: {
        updatedProjectAccount: null,
        updatingProjectAccount: false,
        updateProjectAccountStatus: null
    },
    projectAccountDelete: {
        deletingProjectAccount: false,
        deleteProjectAccountStatus: null
    },
    projectAccountSearch: {
        projectAccountsCount: null,
        projectAccounts: [],
        searchingProjectAccounts: false,
        searchProjectAccountStatus: null
    },
}
const mutations = {
    ['SET_MASTER_ACCOUNT_CREATE'](state, change) {
        state.masterMasterAccountCreate = { ...state.masterMasterAccountCreate, ...change };
    },
    ['SET_MASTER_ACCOUNT_UPDATE'](state, change) {
        state.masterMasterAccountUpdate = { ...state.masterMasterAccountUpdate, ...change };
    },
    ['SET_MASTER_ACCOUNT_DELETE'](state, change) {
        state.masterMasterAccountDelete = { ...state.masterMasterAccountDelete, ...change };
    },
    ['SET_MASTER_ACCOUNT_SEARCH'](state, change) {
        state.masterMasterAccountSearch = { ...state.masterMasterAccountSearch, ...change };
    },
    ['SET_INVESTOR_ACCOUNT_CREATE'](state, change) {
        state.investorAccountCreate = { ...state.investorAccountCreate, ...change };
    },
    ['SET_INVESTOR_ACCOUNT_UPDATE'](state, change) {
        state.investorAccountUpdate = { ...state.investorAccountUpdate, ...change };
    },
    ['SET_INVESTOR_ACCOUNT_DELETE'](state, change) {
        state.investorAccountDelete = { ...state.investorAccountDelete, ...change };
    },
    ['SET_INVESTOR_ACCOUNT_SEARCH'](state, change) {
        state.investorAccountSearch = { ...state.investorAccountSearch, ...change };
    },
    ['SET_PROJECT_ACCOUNT_CREATE'](state, change) {
        state.projectAccountCreate = { ...state.projectAccountCreate, ...change };
    },
    ['SET_PROJECT_ACCOUNT_UPDATE'](state, change) {
        state.projectAccountUpdate = { ...state.projectAccountUpdate, ...change };
    },
    ['SET_PROJECT_ACCOUNT_DELETE'](state, change) {
        state.projectAccountDelete = { ...state.projectAccountDelete, ...change };
    },
    ['SET_PROJECT_ACCOUNT_SEARCH'](state, change) {
        state.projectAccountSearch = { ...state.projectAccountSearch, ...change };
    }
}
const actions = {
    createMasterAccount: ({ commit }, payload) => {
        commit('SET_MASTER_ACCOUNT_CREATE', { createMasterAccountStatus: null, createdMasterAccount: null, creatingMasterAccount: true })
        return Vue.http.post(API_URL + '/accounts/create', payload).then(response => {
            commit('SET_MASTER_ACCOUNT_CREATE', { createMasterAccountStatus: 'success', createdMasterAccount: response.body.results.masterMasterAccount });
        }).catch(response => {
            commit('SET_MASTER_ACCOUNT_CREATE', { createMasterAccountStatus: 'failed' });
        }).finally(() => {
            commit('SET_MASTER_ACCOUNT_CREATE', { creatingMasterAccount: false });
        });
    },
    updateMasterAccount: ({ commit }, payload) => {
        commit('SET_MASTER_ACCOUNT_UPDATE', { updateMasterAccountStatus: null, updatedMasterAccount: null, updatingMasterAccount: true })
        return Vue.http.post(API_URL + '/accounts/update/' + payload.id, payload)
            .then(response => {
                commit('SET_MASTER_ACCOUNT_UPDATE', { updateMasterAccountStatus: 'success', updatedMasterAccount: response.body.results.masterMasterAccount });
            })
            .catch(response => {
                commit('SET_MASTER_ACCOUNT_UPDATE', { updateMasterAccountStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_MASTER_ACCOUNT_UPDATE', { updatingMasterAccount: false });
            })
    },
    deleteMasterAccount: ({ commit }, id) => {
        commit('SET_MASTER_ACCOUNT_DELETE', { deleteMasterAccountStatus: null, deletedMasterAccount: null, deletingMasterAccount: true })
        return Vue.http.delete(API_URL + '/accounts/delete/' + id).then(response => {
            commit('SET_MASTER_ACCOUNT_DELETE', { deleteMasterAccountStatus: 'success' });
        }).catch(response => {
            commit('SET_MASTER_ACCOUNT_DELETE', { deleteMasterAccountStatus: 'failed' });
        }).finally(() => {
            commit('SET_MASTER_ACCOUNT_DELETE', { deletingMasterAccount: false });
        })
    },
    searchMasterAccounts: ({ commit }, payload = { filter: MasterAccountsFilter(), resultMode: 'default' }) => {
        commit('SET_MASTER_ACCOUNT_SEARCH', { searchMasterAccountStatus: null, searchMasterAccount: null, searchingMasterAccounts: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/accounts' + params).then(response => {
            commit('SET_MASTER_ACCOUNT_SEARCH', { searchMasterAccountStatus: 'success', masterMasterAccounts: response.body.results.masterMasterAccounts });
        }).catch(response => {
            commit('SET_MASTER_ACCOUNT_SEARCH', { searchMasterAccountStatus: 'failed' });
        }).finally(() => {
            commit('SET_MASTER_ACCOUNT_SEARCH', { searchingMasterAccounts: false });
        })
    },
    createInvestorAccount: ({ commit }, payload) => {
        commit('SET_INVESTOR_ACCOUNT_CREATE', { createInvestorAccountStatus: null, createdInvestorAccount: null, creatingInvestorAccount: true })
        return Vue.http.post(API_URL + '/investors/accounts/create', payload).then(response => {
            commit('SET_INVESTOR_ACCOUNT_CREATE', { createInvestorAccountStatus: 'success', createdInvestorAccount: response.body.results.investorAccount });
        }).catch(response => {
            commit('SET_INVESTOR_ACCOUNT_CREATE', { createInvestorAccountStatus: 'failed' });
        }).finally(() => {
            commit('SET_INVESTOR_ACCOUNT_CREATE', { creatingInvestorAccount: false });
        });
    },
    updateInvestorAccount: ({ commit }, payload) => {
        commit('SET_INVESTOR_ACCOUNT_UPDATE', { updateInvestorAccountStatus: null, updatedInvestorAccount: null, updatingInvestorAccount: true })
        return Vue.http.post(API_URL + '/investors/accounts/update/' + payload.id, payload)
            .then(response => {
                commit('SET_INVESTOR_ACCOUNT_UPDATE', { updateInvestorAccountStatus: 'success', updatedInvestorAccount: response.body.results.investorAccount });
            })
            .catch(response => {
                commit('SET_INVESTOR_ACCOUNT_UPDATE', { updateInvestorAccountStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_INVESTOR_ACCOUNT_UPDATE', { updatingInvestorAccount: false });
            })
    },
    deleteInvestorAccount: ({ commit }, id) => {
        commit('SET_INVESTOR_ACCOUNT_DELETE', { deleteInvestorAccountStatus: null, deletedInvestorAccount: null, deletingInvestorAccount: true })
        return Vue.http.delete(API_URL + '/investors/accounts/delete/' + id).then(response => {
            commit('SET_INVESTOR_ACCOUNT_DELETE', { deleteInvestorAccountStatus: 'success' });
        }).catch(response => {
            commit('SET_INVESTOR_ACCOUNT_DELETE', { deleteInvestorAccountStatus: 'failed' });
        }).finally(() => {
            commit('SET_INVESTOR_ACCOUNT_DELETE', { deletingInvestorAccount: false });
        })
    },
    searchInvestorAccounts: ({ commit }, payload = { filter: InvestorAccountsFilter(), resultMode: 'default' }) => {
        commit('SET_INVESTOR_ACCOUNT_SEARCH', { searchInvestorAccountStatus: null, searchInvestorAccount: null, searchingInvestorAccounts: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/investors/accounts' + params).then(response => {
            commit('SET_INVESTOR_ACCOUNT_SEARCH', { searchInvestorAccountStatus: 'success', investorAccounts: response.body.results.investorAccounts });
        }).catch(response => {
            commit('SET_INVESTOR_ACCOUNT_SEARCH', { searchInvestorAccountStatus: 'failed' });
        }).finally(() => {
            commit('SET_INVESTOR_ACCOUNT_SEARCH', { searchingInvestorAccounts: false });
        })
    },
    createProjectAccount: ({ commit }, payload) => {
        commit('SET_PROJECT_ACCOUNT_CREATE', { createProjectAccountStatus: null, createdProjectAccount: null, creatingProjectAccount: true })
        return Vue.http.post(API_URL + '/projects/accounts/create', payload).then(response => {
            commit('SET_PROJECT_ACCOUNT_CREATE', { createProjectAccountStatus: 'success', createdProjectAccount: response.body.results.projectAccount });
        }).catch(response => {
            commit('SET_PROJECT_ACCOUNT_CREATE', { createProjectAccountStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_ACCOUNT_CREATE', { creatingProjectAccount: false });
        });
    },
    updateProjectAccount: ({ commit }, payload) => {
        commit('SET_PROJECT_ACCOUNT_UPDATE', { updateProjectAccountStatus: null, updatedProjectAccount: null, updatingProjectAccount: true })
        return Vue.http.post(API_URL + '/projects/accounts/update/' + payload.id, payload)
            .then(response => {
                commit('SET_PROJECT_ACCOUNT_UPDATE', { updateProjectAccountStatus: 'success', updatedProjectAccount: response.body.results.projectAccount });
            })
            .catch(response => {
                commit('SET_PROJECT_ACCOUNT_UPDATE', { updateProjectAccountStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_PROJECT_ACCOUNT_UPDATE', { updatingProjectAccount: false });
            })
    },
    deleteProjectAccount: ({ commit }, id) => {
        commit('SET_PROJECT_ACCOUNT_DELETE', { deleteProjectAccountStatus: null, deletedProjectAccount: null, deletingProjectAccount: true })
        return Vue.http.delete(API_URL + '/projects/accounts/delete/' + id).then(response => {
            commit('SET_PROJECT_ACCOUNT_DELETE', { deleteProjectAccountStatus: 'success' });
        }).catch(response => {
            commit('SET_PROJECT_ACCOUNT_DELETE', { deleteProjectAccountStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_ACCOUNT_DELETE', { deletingProjectAccount: false });
        })
    },
    searchProjectAccounts: ({ commit }, payload = { filter: ProjectAccountsFilter(), resultMode: 'default' }) => {
        commit('SET_PROJECT_ACCOUNT_SEARCH', { searchProjectAccountStatus: null, searchProjectAccount: null, searchingProjectAccounts: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/projects/accounts' + params).then(response => {
            commit('SET_PROJECT_ACCOUNT_SEARCH', { searchProjectAccountStatus: 'success', projectAccounts: response.body.results.projectAccounts });
        }).catch(response => {
            commit('SET_PROJECT_ACCOUNT_SEARCH', { searchProjectAccountStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_ACCOUNT_SEARCH', { searchingProjectAccounts: false });
        })
    },

}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/accountsStore.js